export { default } from "./src/call-to-action";
export type { UniformCallToActionProps } from "./src/call-to-action";
